import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Card, Col, Row } from 'reactstrap'
import { ListPagination } from 'components/organisms'

const propTypes = {
  cmsMedia           : PropTypes.array,
  onClickMedia       : PropTypes.func,
  onDoubleClickMedia : PropTypes.func,
  onClickPage        : PropTypes.func,
  pagination         : PropTypes.object
}

const defaultProps = {
  cmsMedia           : [],
  onClickMedia       : () => { },
  onDoubleClickMedia : () => { },
  onClickPage        : () => { },
  pagination         : {}

}

const CmsMediaCardList = ({
  cmsMedia,
  onClickMedia,
  onDoubleClickMedia,
  onClickPage,
  pagination
}) => {
  const [ activeCard, setActiveCard ] = useState()

  const isActive = (mediaId) => (activeCard == mediaId)

  const handleClickMedia       = (media) => {
    onClickMedia(media)
    setActiveCard(media.id)
  }
  const handleDoubleClickMedia = (media) => {
    onDoubleClickMedia(media)
  }
  return (
    <>
      <Row className='my-2'>
        {
          cmsMedia.map((media) => (
            <Col
              sm={ 12 }
              md={ 6 }
              xl={ 3 }
              key={ `cms-media-${media.id}` }
            >
              <Card body
                className={ `mx-auto ${isActive(media.id) && 'bg-primary mb-3 text-white'}` }
              >
                <a
                  onClick={ () => handleClickMedia(media) }
                  onDoubleClick={ () => handleDoubleClickMedia(media) }
                >
                  <img
                    className='w-100'
                    src={ media.url }
                  />
                  <span>{ media.file_name }</span>
                </a>
              </Card>
            </Col>
          ))
        }
      </Row>
      <ListPagination
        pagination={ pagination }
        onClickPage={ onClickPage }
      />
    </>
  )
}

CmsMediaCardList.propTypes    = propTypes
CmsMediaCardList.defaultProps = defaultProps

export default CmsMediaCardList
